var exports = {
  "K": "HeroSection__tYSVSm",
};

module.exports = exports;
